import { render, staticRenderFns } from "./EsqueciSenha.vue?vue&type=template&id=3ce7b2a8&scoped=true"
import script from "./EsqueciSenha.vue?vue&type=script&lang=ts"
export * from "./EsqueciSenha.vue?vue&type=script&lang=ts"
import style0 from "./EsqueciSenha.vue?vue&type=style&index=0&id=3ce7b2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce7b2a8",
  null
  
)

export default component.exports